module.exports = __webpack_public_path__ + "img/options.c9beba7b.svg";